<template>
    <div class="block--small">
        <h2 v-if="!busy && !error" class="js_missing">
            {{$t('single_sign_on.header_no_sso')}}
        </h2>
        <h2 v-else-if="busy" class="js_busy">
            {{$t('single_sign_on.header_sso_busy')}}
        </h2>
        <h2 v-else-if="error" class="js_error">
            {{$t('single_sign_on.header_sso_error')}}
        </h2>
        <p>
            <a v-if="unauthorizedUrl" :href="unauthorizedUrl" class="button--cta">
                {{$t('single_sign_on.link_go_back')}}
            </a>
            <router-link v-else :to="{ name: 'home' }" class="button--cta">
                {{$t('single_sign_on.link_go_back')}}
            </router-link>
        </p>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Watch} from 'vue-property-decorator';
    import axios from 'axios';
    import {LOGIN_SSO} from '../../../store/modules/auth';

    @Component
    export default class SingleSignOnForm extends Vue {
        busy = null;
        error = false;

        created() {
            this.onRouteChanged();
        }

        @Watch('$route.hash')
        onRouteChanged() {
            if (!this.$route.hash) {
                console.log('[ SSO ]', 'No hash on route');
                return;
            }
            if (this.busy) {
                this.busy.cancel('Hash changed');
                this.busy = null;
            }
            const token = this.$route.hash.substr(1);
            if (!token) {
                console.log('[ SSO ]', 'No token specified');
                return;
            }
            this.busy = axios.CancelToken.source();
            this.error = false;
            console.log('[ SSO ]', 'Using token');
            this.$store.dispatch(LOGIN_SSO, token)
                .then(() => {
                    console.log('[ SSO ]', 'Success');
                    this.error = false;
                    this.onLogin();
                })
                .catch(() => {
                    console.log('[ SSO ]', 'Failed');
                    this.error = true;
                })
                .finally(() => this.busy = null);
        }

        onLogin() {
            const redirect = this.$route.query.redirect || {name: 'home'};
            console.log('[ SSO ]', 'Redirect', redirect);
            this.$router.replace(redirect);
        }

        get unauthorizedUrl() {
            if (this.$config.redirects && this.$config.redirects.unauthorized) {
                return this.$config.redirects.unauthorized;
            } else {
                return undefined;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/auth/forms/SingleSignOnForm.vue